
export const AXIOS_DEFAULTS_URL = '';
export const AXIOS_DEFAULTS_PARAMS = {};
export const AXIOS_DEFAULTS_METHOD = 'get';
export const AXIOS_DEFAULTS_TIMEOUT = 60000;
export const AXIOS_DEFAULTS_CONTENT_TYPE ='form';
export const AXIOS_DEFAULTS_RESPONSE_TYPE = 'json';
